import { userActivityLogActionTypes } from './userActivityLog.types';
import http from '../../services/http';

export const selectUserActivityLogs = state => state.userActivityLogs?.logs || [];
export const selectUserActivityLogStatistics = state => state.userActivityLogs?.statistics || null;
export const selectUserActivityLogLoading = state => state.userActivityLogs?.loading || false;
export const selectUserActivityLogError = state => state.userActivityLogs?.error || null;

const setUserActivityLogs = logs => {
    return {
        type: userActivityLogActionTypes.SET_USER_ACTIVITY_LOGS,
        payload: logs
    };
};

const setUserActivityLogStatistics = statistics => {
    return {
        type: userActivityLogActionTypes.SET_USER_ACTIVITY_LOG_STATISTICS,
        payload: statistics
    };
};

const setLoading = loading => {
    return {
        type: userActivityLogActionTypes.SET_LOADING,
        payload: loading
    };
};

const setError = error => {
    return {
        type: userActivityLogActionTypes.SET_ERROR,
        payload: error
    };
};

export const getUserActivityLogs = (filters = {}) => {
    return async dispatch => {
        dispatch(setLoading(true));
        dispatch(setError(null));
        
        try {
            const params = new URLSearchParams();
            
            if (filters.user_id) params.append('user_id', filters.user_id);
            if (filters.action_type) params.append('action_type', filters.action_type);
            if (filters.entity_type) params.append('entity_type', filters.entity_type);
            if (filters.limit) params.append('limit', filters.limit);
            if (filters.offset) params.append('offset', filters.offset);
            
            const queryString = params.toString();
            const url = `/user-activity-logs${queryString ? `?${queryString}` : ''}`;
            
            const response = await http.get(url);
            dispatch(setUserActivityLogs(response.data));
            dispatch(setLoading(false));
        } catch (error) {
            console.error('Erro ao buscar logs de atividades:', error);
            dispatch(setError(error.response?.data?.error || 'Erro ao carregar logs de atividades'));
            dispatch(setLoading(false));
        }
    };
};

export const getUserActivityLogStatistics = (filters = {}) => {
    return async dispatch => {
        try {
            const params = new URLSearchParams();
            
            if (filters.user_id) params.append('user_id', filters.user_id);
            if (filters.start_date) params.append('start_date', filters.start_date);
            if (filters.end_date) params.append('end_date', filters.end_date);
            
            const queryString = params.toString();
            const url = `/user-activity-logs/statistics${queryString ? `?${queryString}` : ''}`;
            
            const response = await http.get(url);
            dispatch(setUserActivityLogStatistics(response.data));
        } catch (error) {
            console.error('Erro ao buscar estatísticas:', error);
            dispatch(setError(error.response?.data?.error || 'Erro ao carregar estatísticas'));
        }
    };
};
